import React, { useEffect } from "react";
import Select from "../Select/Select";
import TextInput from "../TextInput/TextInput";
import RadioButtonGroup from "../RadioButtonGroup/RadioButtonGroup";
import FileUpload from "../FileUpload/FileUpload";
import MultiFileUpload from "../MultiFileUpload/MultiFileUpload";
import MultiSelectWrapper from "../MultiSelect/MultiSelect";
import DatePicker from "../DatePicker/DatePicker";
import TextareaInput from "../TextareaInput/TextareaInput";
import HierarchySelect from "../HierarchySelect/HierarchySelect";
import Checkbox from "../Checkbox/Checkbox";
import FileUploadForMR from "../FileUploadForMasterResource/FileUploadForMR";
import SearchDropdown from "../SearchDropdown/SearchDropdown";
import SingleSelect from "../SearchDropdown/SearchDropdown";
import TimePicker from "../TimePicker/TimePicker";
import InputWithDynamicFields from "../TextInputForDynamicFields/TextInputDynamic";
import CheckboxGroup from "../Checkbox/MultiCheckBox";
import RadioButtonGroups from "../RadioButton/RadioButton";
import CheckboxGroupMulti from "../Checkbox/MultiCheckBoxForCheck";
import CheckboxGroupWeb from "../Checkbox/MultiCheckboxForMobile";
import MultiSelectWrapperForRole from "../MultiSelect/multiSelectForRole";
import HierarchySelectForRole from "../HierarchySelect/HireSelectForRole";
import DateTimePicker from "../DatePicker/DateTimePicker";
import CustomButton from "../DatePicker/CustomButton";
import IncidentMultiselect from "../MultiSelect/IncidentMultiselect";
import MultiFileUploadForTask from "../MultiFileUpload/MultiFileUploadForTask";

// import MapWrapper from "../../../../../Components/UiComponents/MapWrapper/MapWrapper";

const FormHandler = ({
  register,
  errors,
  setValue,
  setValueForInput,
  getValues,
  fields,
  columns,
  control = {},
  setvendorName,
  onChange,
  checkboxOnChange,
  onChangeForRegion,
  openMapHandler,
  is_multi,
  isMultiSelectDisabled,
  imgName,
  isTextFieldDisable,
  roleName,
  isTextFieldDisableforrole,
  Description,
  addresses,
  webaccess,
  mobileAccess,
  handleShow,
  textareaConfig,
  handleFileChange,
  uploadfilewidth,
  existingFileCount = 0,
}) => {
  // Function to check if "Quantity" should be disabled
  //const isQuantityDisabled = contactType === "Individual";
  //console.log("isQuantityDisabled=", isQuantityDisabled);

  // Helper function to determine if a field is mandatory *
  const isFieldMandatory = (field) => {
    if (typeof field.mandatory === "function") {
      const formValues = getValues ? getValues() : {};
      return field.mandatory(formValues);
    }
    return field.mandatory === "true";
  };

  const generateField = (field) => {
    let component;
    const {
      name,
      label,
      options,
      type,
      mandatory,
      id,
      heading,
      label1,
      label2,
      maxLength,
      disabled,
      is_multi,
      editId,
      defaultselect,
      disableField,
      style,
      parentLabel,
      placeholder,
    } = field;

    // Determine if the field is mandatory based on the dynamic logic
    const isMandatory = isFieldMandatory(field);
    const isDisabled =
      typeof field.disabled === "function"
        ? field.disabled({ roleName })
        : field.disabled || isTextFieldDisable || disableField;

    switch (type) {
      case "input":
        component = (
          <TextInput
            name={name}
            label={label}
            maxLength={maxLength}
            register={register}
            errors={errors}
            mandatory={
              field.name === "Latitude" || field.name === "longitude"
                ? isMandatory
                : mandatory
            }
            disabled={isDisabled || Description}
            openMapHandler={openMapHandler}
            isTextFieldDisable={isTextFieldDisable}
            Description={Description}
            style={style}
            uploadfilewidth={uploadfilewidth}
          />
        );
        break;
      case "dynamic_input":
        component = (
          <InputWithDynamicFields
            name={name}
            label={label}
            register={register}
            errors={errors}
            mandatory={mandatory}
            maxFields={field.maxFields}
            maxLength={maxLength}
            setValue={setValueForInput}
            disabled={isDisabled}
            style={style}
            addresses={addresses}
          />
        );
        break;
      case "checkboxmulti":
        component = (
          <CheckboxGroup
            key={`checkbox-group-${webaccess}`}
            options={field.options} // Pass multiple checkboxes
            name={name}
            label={label}
            control={control}
            mandatory={mandatory}
            id={id}
            heading={heading}
            parentLabel={parentLabel}
            disabled={!webaccess || disableField}
            webaccess={!webaccess}
          />
        );
        break;
      case "checkboxmultiGroup":
        component = (
          <CheckboxGroupMulti
            options={field.options} // Pass multiple checkboxes
            name={name}
            label={label}
            control={control}
            mandatory={mandatory}
            id={id}
            heading={heading}
            parentLabel={parentLabel}
          // disabled={hasWebAccess || disableField}
          // hasWebAccess={hasWebAccess}
          />
        );
        break;
      case "checkboxmultiGroupWeb":
        component = (
          <CheckboxGroupWeb
            options={field.options} // Pass multiple checkboxes
            name={name}
            label={label}
            control={control}
            mandatory={mandatory}
            id={id}
            heading={heading}
            parentLabel={parentLabel}
            disabled={!mobileAccess || disableField}
            mobileAccess={!mobileAccess}
          />
        );
        break;
      case "radio":
        component = (
          <RadioButtonGroups // Make sure this matches your component name
            options={options} // This should come from field.options
            name={name}
            control={control}
            parentLabel={parentLabel || label}
            mandatory={mandatory}
            disabled={webaccess || disableField}
            webaccess={webaccess}
          />
        );
        break;
      case "select":
        component = (
          <Select
            name={name}
            label={label}
            register={register}
            errors={errors}
            options={options}
            mandatory={mandatory}
            defaultselect={defaultselect}
            disabled={disabled || isTextFieldDisable || disableField}
            isTextFieldDisable={isTextFieldDisable}
            style={style}
            placeholder={placeholder}
          />
        );
        break;
      case "single_select":
        component = (
          <SearchDropdown
            name={name}
            label={label}
            register={register}
            errors={errors}
            options={options}
            onChange={onChange}
            control={control}
            mandatory={mandatory}
            style={style}
          />
        );
        break;

      case "hier_select":
        component = (
          <HierarchySelect
            name={name}
            label={label}
            register={register}
            errors={errors}
            options={options}
            onChange={onChange}
            control={control}
            mandatory={mandatory}
            disabled={disabled}
            isTextFieldDisableforrole={isTextFieldDisableforrole}
          // mobileAccess={!mobileAccess}
          />
        );
        break;
      case "hier_select_for_role": {
        const isWebPermissionDisabled = disabled || !mobileAccess;
        component = (
          <div>
            <HierarchySelectForRole
              name={name}
              label={label}
              register={register}
              errors={errors}
              options={options}
              onChange={onChange}
              control={control}
              mandatory={mandatory}
              disabled={isWebPermissionDisabled}
              isTextFieldDisableforrole={isTextFieldDisableforrole}
              mobileAccess={!mobileAccess}
              treeKey={field.treeKey}
            />
            {isWebPermissionDisabled && (
              <div style={{ fontSize: "11px", color: "#94A3B8", marginTop: "4px" }}>
                Enable Web Access to select Web Permissions
              </div>
            )}
          </div>
        );
        break;
      }
      case "multi_select":
        component = (
          <MultiSelectWrapper
            name={name}
            label={label}
            register={register}
            errors={errors}
            is_multi={is_multi}
            options={options}
            mandatory={mandatory}
            control={control}
            // disabled={disabled}
            // disabled={isMultiSelectDisabled && (name != "contact_list" && name != "region_id") || isTextFieldDisable}
            isMultiSelectDisabled={isMultiSelectDisabled}
            disabled={disabled || isTextFieldDisable}
            onChangeForRegion={onChangeForRegion}
            isTextFieldDisable={isTextFieldDisable}
            multiselcinci={textareaConfig}
          // webAccess={!webaccess}
          />
        );
        break;
      case "multi_select1":
        component = (
          <IncidentMultiselect
            name={name}
            label={label}
            register={register}
            errors={errors}
            is_multi={true}
            options={options}
            mandatory={mandatory}
            control={control}
            isMultiSelectDisabled={isMultiSelectDisabled}
            disabled={disabled || isTextFieldDisable}
            onChangeForRegion={onChangeForRegion}
            isTextFieldDisable={isTextFieldDisable}
            multiselcinci={textareaConfig}
            getOptionValue={option => option.id}  // How to get value from options
            getOptionLabel={option => option.user_name}

          />
        );
        break;
      case "multi_select_role": {
        const isMobilePermissionDisabled = disabled || isTextFieldDisable || !webaccess;
        component = (
          <div>
            <MultiSelectWrapperForRole
              name={name}
              label={label}
              register={register}
              errors={errors}
              is_multi={is_multi}
              options={options}
              mandatory={mandatory}
              control={control}
              // disabled={disabled}
              // disabled={isMultiSelectDisabled && (name != "contact_list" && name != "region_id") || isTextFieldDisable}
              isMultiSelectDisabled={isMultiSelectDisabled}
              disabled={isMobilePermissionDisabled}
              onChangeForRegion={onChangeForRegion}
              isTextFieldDisable={isTextFieldDisable}
              webAccess={!webaccess}
              key={field.treeKey}
            />
            {isMobilePermissionDisabled && (
              <div style={{ fontSize: "11px", color: "#94A3B8", marginTop: "4px" }}>
                Enable Mobile Access to select Mobile Permissions
              </div>
            )}
          </div>
        );
        break;
      }


      case "file_upload":
        component = (
          <FileUpload
            label={label}
            register={register}
            name={name}
            errors={errors}
            mandatory={mandatory}
            control={control}
            id={id}
            setValue={setValue}
            getValues={getValues}
            editId={editId}
          />
        );
        break;
      case "file_upload_MR":
        component = (
          <FileUploadForMR
            label={label}
            register={register}
            name={name}
            errors={errors}
            mandatory={mandatory}
            control={control}
            id={id}
            setValue={setValue}
            getValues={getValues}
            editId={editId}
            imgName={imgName}

          />
        );
        break;
      case "multi_file_upload":
        component = (
          <MultiFileUpload
            label={label}
            register={register}
            name={name}
            errors={errors}
            mandatory={mandatory}
            control={control}
            id={id}
            setValue={setValue}
            getValues={getValues}
            editId={editId}
            handleFileChange={handleFileChange}
            uploadfilewidth={uploadfilewidth}
          />
        );
        break;
      case "multi_file_upload_For_Task":
        component = (
          <MultiFileUploadForTask
            label={label}
            register={register}
            name={name}
            errors={errors}
            mandatory={mandatory}
            control={control}
            id={id}
            setValue={setValue}
            getValues={getValues}
            editId={editId}
            handleFileChange={handleFileChange}
            uploadfilewidth={uploadfilewidth}
            existingFileCount={existingFileCount}
          />
        );
        break;
      case "text_area":
        component = (
          <TextareaInput
            label={label}
            register={register}
            name={name}
            errors={errors}
            mandatory={mandatory}
            control={control}
            id={id}
            disabled={isTextFieldDisable || Description}
            Description={Description}
            isTextFieldDisable={isTextFieldDisable}
            textareaConfig={textareaConfig}
            maxLength={maxLength}
          />
        );
        break;
      case "checkbox":
        component = (
          <Checkbox
            label={label}
            onChange={checkboxOnChange}
            name={name}
            mandatory={mandatory}
            control={control}
            id={id}
            heading={heading}
          />
        );
        break;
      // case "map":
      //   component = (
      //     <MapWrapper
      //       label2={label2}
      //       // register={register}
      //       name={name}
      //       errors={errors}
      //       mandatory={mandatory}
      //       control={control}
      //       id={id}
      //       heading={heading}
      //     />
      //   );
      //   break;

      case "date":
        component = (
          <DatePicker
            label={label}
            register={register}
            name={name}
            errors={errors}
            mandatory={field.name === "paymentDate" ? isMandatory : mandatory}
            disabled={disabled || isTextFieldDisable || disableField}
          />
        );
        break;
      case "time":
        component = (
          <TimePicker
            name={name}
            label={label}
            register={register}
            errors={errors}
            mandatory={mandatory}
            defaultTimeValue={field.defaultTimeValue}
            disabled={isTextFieldDisable || disableField}
            setTimePicked={setValue}
            style={style}
          />
        );
        break;
      case "datetime":
        component = (
          <DateTimePicker
            name={name}
            label={label}
            control={control}
            register={register} // Add register prop
            errors={errors}
            mandatory={mandatory}
            disabled={isTextFieldDisable || disableField}
            style={style}
            setValue={setValue} // Add setValue prop
            getValues={getValues} // Add getValues prop
          />
        );
        break;
      case "button":
        component = (
          <CustomButton
            name={name}
            label={label}
            control={control}
            errors={errors}
            mandatory={mandatory}
            disabled={isTextFieldDisable || disableField}
            style={style}
            icon={<i className="bi bi-plus-circle" />}
            buttonText="Add Region"
            handleShow={handleShow}
          />
        );
        break;

      default:
        break;
    }
    return component;
  };

  // Effect to handle dynamic field updates
  useEffect(() => {
    if (getValues && setValue) {
      const handleFieldUpdates = () => {
        const values = getValues();
        fields.forEach((field) => {
          if (typeof field.mandatory === "function") {
            // Trigger form validation if needed
            if (field.name === "paymentDate" && values.paymentStatus !== "0") {
              setValue("paymentDate", "");
            }
          }
        });
      };

      handleFieldUpdates();
    }
  }, [fields, getValues, setValue]);

  const styles = {
    columnCount: columns,
    columnGap: "30%", // sets the size of the gap between columns
    display: "grid",
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    gap: "0.9rem",
  };

  return (
    <div
      style={{
        ...styles,
        ...(fields.some((field) => field.type === "dynamic_input") && {
          gridTemplateColumns: "1fr",
        }),
      }}
    >
      {fields?.map((field) => (
        <div
          key={field.name}
          style={{
            paddingLeft: "1.2rem",
            paddingRight: "1.2rem",
            ...(field.type === "dynamic_input" && { gridColumn: "span 1" }), // Ensure dynamic input fields take full width
            ...(field.fullWidth && { gridColumn: "1 / -1" }),
          }}
        >
          {generateField(field)}
        </div>
      ))}
    </div>
  );
};
export default FormHandler;
